import { t } from 'i18next'
import { z } from 'zod'

import { origemTelefone } from '@/shared/interfaces/cliente.enums'
import { StringUtils } from '@/shared/utils'
import { DIGITOS_MAXIMOS_TELEFONE_BRASIL_PF, DIGITOS_MAXIMOS_TELEFONE_INTERNACIONAL } from '@/shared/utils/constants'

const DDD_BRASIL = '55'

export const telefoneSchema = (digitosMaximos = DIGITOS_MAXIMOS_TELEFONE_BRASIL_PF) =>
  z
    .object({
      numero: z.string(),
      origem: z.enum(origemTelefone).default(origemTelefone.Brasil),
      principal: z.boolean().default(true),
    })
    .nullish()
    .superRefine((telefone, ctx) => {
      if (!telefone?.numero) {
        ctx.addIssue({ code: 'custom', message: t('common:telefone.informe_telefone'), path: ['numero'] })
        return
      }

      const formattedNumber = StringUtils.removeSpecialCharacters(telefone?.numero)
      const isBrazilianPhone = formattedNumber.startsWith(DDD_BRASIL)

      if (telefone?.origem === origemTelefone.Brasil) {
        if (formattedNumber.length < digitosMaximos) {
          ctx.addIssue({
            code: 'custom',
            message: t('common:telefone.validacao.minimo_brasil', { numero: digitosMaximos }),
            path: ['numero'],
          })
        }
      } else {
        const isTooShortFortIntl = isBrazilianPhone && formattedNumber.length < DIGITOS_MAXIMOS_TELEFONE_INTERNACIONAL
        if (isTooShortFortIntl) {
          ctx.addIssue({
            code: 'custom',
            message: t('common:telefone.validacao.minimo_internacional'),
            path: ['numero'],
          })
        }
      }
    })
